// used by color selectors in edit views
// use _colors.scss to add css for new colors
export const colors = [
  "transparent",
  "white",
  "black",
  "blue",
  "light-blue",
  "orange",
  "yellow",
  "gray",
  "light-gray",
  "lighter-gray",
  // colors for liv
  "teal",
  "light-teal",
  "dark-teal",
  "transparent-white",
  "transparent-black",
  "transparent-white-low",
  "transparent-black-low",
];

// used by section, box and bento box widgets
export const sectionColors = [
  "transparent",
  "white",
  "blue",
  "light-blue",
  "lighter-gray",
  "light-gray",
  // colors for liv
  "teal",
  "light-teal",
  "transparent-white",
  "transparent-black",
  "transparent-white-low",
  "transparent-black-low",
];

export const buttonColors = [
  "white",
  "blue",
  "light-blue",
  "yellow",
  "teal",
  "light-teal",
];
